var exports = {
  "k": "xe533113f--ab854d--container",
};

module.exports = exports;
